export const BILLING_ADDRESS_ROWS = [
  [
    { name: 'firstName' as const, label: 'First Name' },
    { name: 'lastName' as const, label: 'Last Name' },
  ],
  [
    { name: 'country' as const, label: 'Country/Region' },
    { name: 'city' as const, label: 'City' },
  ],
];

export const BILLING_ADDRESS_ROWS_BOTTOM = [
  [
    { name: 'state' as const, label: 'State' },
    { name: 'zipCode' as const, label: 'Zip code' },
  ],
];

export const BILLING_DAY_OPTIONS = Array.from({ length: 28 }, (_, i) => i + 1);

export const PERSONAL_NAME_ROW = [
  { name: 'firstName' as const, label: 'First Name' },
  { name: 'lastName' as const, label: 'Last Name' },
];
